import BaseService from "../BaseService";
import _ from "lodash";

class ProductCategoryService extends BaseService {
    list = async ({ info } = {}) => {
        var data = await this._api.get("/product_category/list", { params: { info: info } });
        return data;
    };

    update = async ({ id, name }) => {
        var data = await this._api.post(`/product_category/update`, { id, name });
        return data;
    };

    create = async ({ name }) => {
        var data = await this._api.post(`/product_category/create`, { name });
        return data;
    };


    get = async (id) => {
        var data = await this._api.get(`/product_category/get`, { params: { id: id } });
        return data;
    };


    delete = async (id) => {
        var data = await this._api.post(`/product_category/delete`, { id: id });
        return data;
    };



}
export default ProductCategoryService;
